"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyBookingDtoSchema = exports.CompanyBookingStatus = void 0;
const zod_1 = require("zod");
/**
 * Status of a booking as shown to company admins. Distinct from the
 * unrelated `BookingStatus` in `./booking` — that type describes a
 * different (currently unused) booking shape with its own status vocabulary.
 */
var CompanyBookingStatus;
(function (CompanyBookingStatus) {
    CompanyBookingStatus["Confirmed"] = "confirmed";
    CompanyBookingStatus["Cancelled"] = "cancelled";
    CompanyBookingStatus["PaymentRequired"] = "payment_required";
})(CompanyBookingStatus || (exports.CompanyBookingStatus = CompanyBookingStatus = {}));
// Schema-first (type inferred via `z.infer` below) — see the comment on
// `OrganizationUserDtoSchema` in ./organization for why.
exports.CompanyBookingDtoSchema = zod_1.z.object({
    id: zod_1.z.string(),
    internalBookingId: zod_1.z.string(),
    restAreaId: zod_1.z.string(),
    arrivalTime: zod_1.z.string(),
    endTime: zod_1.z.string(),
    status: zod_1.z.nativeEnum(CompanyBookingStatus),
    productDescription: zod_1.z.string(),
    grossPrice: zod_1.z.number(),
    displayText: zod_1.z.string(),
    userId: zod_1.z.string(),
    userName: zod_1.z.string(),
});
//# sourceMappingURL=company-booking.js.map